export default __webpack_public_path__ + "static/media/door.70fa8756.png";